export function minsSecondsToSeconds ([ mins, seconds ]) {
  return parseInt(mins) * 60 + parseInt(seconds)
}

export function secsToMinsandSecs (seconds) {
  const ms = Number.isNaN(seconds) ? 0 : seconds * 1000

  const date = new Date(ms)
  const secs = padZeros(date.getSeconds().toString())
  const minutes = padZeros(date.getMinutes().toString())
  return [minutes, secs]
}

export function padZeros (string) {
  return String('00' + string).slice(-2)
}



// WEBPACK FOOTER //
// ./src/time.js